interface ApiConfig {
  baseUrl: string;
}

const getApiConfig = (): ApiConfig => {
  const baseUrl = '/api';
  return { baseUrl };
};

export const apiConfig = getApiConfig();

export const buildApiUrl = (path: string): string => {
  return `${apiConfig.baseUrl}${path}`;
};

export const getDefaultHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};
